import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import API from "../api";


const AddPatient = () => {
  const navigate = useNavigate();
  const [hasSubscription, setHasSubscription] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    phone_number: "",
    city: "",
    pin_code: "",
    language: "",
    date_of_birth: "",
    age:"",
    gender: "",
    abha_id: "",

  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });
// Example after API fetch
// setPaymentCompleted(res.data.payment_completed);

   // DOB → AGE
  
   useEffect(() => {
  checkSubscription();
}, []);


const checkSubscription = async () => {
  try {
    const token = localStorage.getItem("token");

    const res = await API.post("/subscription-status", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log(res.data)

    setHasSubscription(res.data.active);
  } catch (err) {
    console.error(err);
    setHasSubscription(false);
  }
};

const calculateAge = (dob) => {
  const birthDate = new Date(dob);
  const today = new Date();

  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();

  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  return age;
};

// AGE → DOB (approx: current year - age)
const calculateDOB = (age) => {
  const today = new Date();
  const year = today.getFullYear() - age;

  // default DOB = Jan 1 of that year
  return `${year}-01-01`;
};

const handleChange = (e) => {
  const { name, value } = e.target;

  // If AGE changes → update DOB
  if (name === "age") {
    const dob = calculateDOB(value);

    setFormData((prev) => ({
      ...prev,
      age: value,
      date_of_birth: dob,
    }));
  }

  // If DOB changes → update AGE
  else if (name === "date_of_birth") {
    const age = calculateAge(value);

    setFormData((prev) => ({
      ...prev,
      date_of_birth: value,
      age: age,
    }));
  }

  // Normal fields
  else {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  }
};

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prev) => ({ ...prev, [name]: value }));
  // };

  

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: "", text: "" });

    try {
      const formattedDOB = new Date(formData.date_of_birth)
        .toLocaleDateString("en-GB"); // dd/mm/yyyy

      const patientPayload = {
        ...formData,
        date_of_birth: formattedDOB,
      };

      console.log("Submitting patient data:", patientPayload);

      const response = await fetch("https://www.careplus.gopillz.com/add_doctor_patient", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(patientPayload),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage({ type: "success", text: "Patient added successfully!" });
        setTimeout(() => navigate("/doctor-dashboard"), 1500);
      } else {
        setMessage({ type: "error", text: data?.error || "Failed to add patient." });
      }
    } catch (error) {
      setMessage({ type: "error", text: "Something went wrong." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <div className="flex justify-center items-start px-4 pt-24 pb-10 min-h-screen bg-blue-50">
        <form
          onSubmit={handleSubmit}
          className="bg-white p-8 rounded-2xl shadow-xl w-full max-w-2xl space-y-6"
        >
          <h2 className="text-2xl sm:text-3xl font-bold text-blue-700 mb-4">Add New Patient</h2>

          {loading && (
            <div className="text-blue-600 text-sm mb-4 animate-pulse">Submitting, please wait...</div>
          )}

          {message.text && (
            <div
              className={`text-sm font-medium px-4 py-2 rounded mb-4 ${message.type === "success"
                  ? "bg-green-100 text-green-700"
                  : "bg-red-100 text-red-700"
                }`}
            >
              {message.text}
            </div>
          )}

          <div>
            <label className="block text-gray-700 font-medium mb-1">Name</label>
            <input
              type="text"
              name="name"
              required
              value={formData.name}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg px-4 py-2"
              placeholder="Enter full name"
            />
          </div>

          <div>
            <label className="block text-gray-700 font-medium mb-1">Phone Number</label>
            <PhoneInput
              country={"in"}
              value={formData.phone_number}
              onChange={(phone) =>
                setFormData((prev) => ({ ...prev, phone_number: phone }))
              }
              inputStyle={{
                width: "100%",
                borderRadius: "0.5rem",
                padding: "0.5rem 1rem",
                border: "1px solid #d1d5db", // Tailwind border-gray-300
              }}
              inputClass="text-sm"
            />
          </div>

       

<div>
  <label className="block text-gray-700 font-medium mb-1">ABHA ID</label>

  <input
    type="text"
    name="abha_id"
    value={formData.abha_id}
    onChange={handleChange}
    placeholder="Enter ABHA ID"
    className="w-full border border-gray-300 rounded-lg px-4 py-2"
  />
</div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
  <label className="block text-gray-700 font-medium mb-1">AGE</label>

  <input
    type="number"
    name="age"
    required
    value={formData.age}
    onChange={handleChange}
    placeholder="Enter age"
    className="w-full border border-gray-300 rounded-lg px-4 py-2"
  />
</div>

            <div>
              <label className="block text-gray-700 font-medium mb-1">Date of Birth</label>


              <input
                type="date"
                name="date_of_birth"
                required
                value={formData.date_of_birth}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-lg px-4 py-2"
              />
            </div>

            <div>
              <label className="block text-gray-700 font-medium mb-1">Gender</label>
              <select
                name="gender"
                required
                value={formData.gender}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-lg px-4 py-2"
              >
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>
            </div>
          </div>

          <div>
            <label className="block text-gray-700 font-medium mb-1">City</label>
            <input
              type="text"
              name="city"
              required
              value={formData.city}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg px-4 py-2"
              placeholder="Enter city"
            />
          </div>

          <div>
            <label className="block text-gray-700 font-medium mb-1">Pin Code</label>
            <input
              type="text"
              name="pin_code"
              required
              value={formData.pin_code}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg px-4 py-2"
              placeholder="Enter area pin code"
            />
          </div>

          <div>
            <label className="block text-gray-700 font-medium mb-1">Preferred Language</label>
            <select
              name="language"
              required
              value={formData.language}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg px-4 py-2"
            >
              <option value="">Select Language</option>
              <option value="English">English</option>
              <option value="Hindi">Hindi</option>
            </select>
          </div>

          <div className="flex justify-end">
            <button
              type="submit"
              disabled={loading}
              className="bg-gradient-to-r from-blue-500 to-blue-700 hover:from-blue-600 hover:to-blue-800 text-white font-semibold px-6 py-2 rounded-full shadow-lg transition hover:scale-105"
            >
              {loading ? "Adding..." : "Add Patient"}
            </button>
          </div>
        </form>
        {!hasSubscription && (
  <div className="fixed inset-0 z-[9999] flex items-center justify-center">

    {/* Background */}
    <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />

    {/* Card */}
    <div className="relative w-[95%] max-w-lg bg-white rounded-3xl shadow-2xl p-8">

      <div className="text-center">

        <div className="w-24 h-24 mx-auto rounded-full bg-gradient-to-r from-blue-500 to-purple-600 flex items-center justify-center text-white text-5xl mb-5">
          💎
        </div>

        <h2 className="text-3xl font-bold text-gray-800 mb-3">
          Subscription Required
        </h2>

        <p className="text-gray-500 mb-6">
          Purchase a subscription plan to unlock
          Add Patient functionality and all premium
          healthcare features.
        </p>

        <div className="bg-blue-50 rounded-2xl p-5 text-left mb-6">
          <ul className="space-y-3 text-sm text-gray-700">
            <li>✅ Add Unlimited Patients</li>
            <li>✅ AI Prescription Analysis</li>
            <li>✅ Smart Recovery Plans</li>
            <li>✅ Patient Health Tracking</li>
            <li>✅ Appointment Management</li>
            <li>✅ SMS Notifications</li>
          </ul>
        </div>

        <button
          onClick={() => navigate("/subscription")}
          className="w-full py-4 rounded-2xl bg-gradient-to-r from-blue-600 to-purple-600 text-white font-semibold hover:scale-105 transition"
        >
          View Subscription Plans
        </button>

      </div>
    </div>
  </div>
)}
      </div>
    </>
  );
};

export default AddPatient;
